var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 3.97498H18.9749V3.14998C18.9749 2.69998 18.5999 2.28748 18.1124 2.28748C17.6249 2.28748 17.25 2.66248 17.25 3.14998V3.93748H6.71245V3.14998C6.71245 2.69998 6.33745 2.28748 5.84995 2.28748C5.36245 2.28748 4.98745 2.66248 4.98745 3.14998V3.93748H2.99995C1.72495 3.93748 0.637451 4.98748 0.637451 6.29998V19.35C0.637451 20.625 1.68745 21.7125 2.99995 21.7125H20.9999C22.275 21.7125 23.3624 20.6625 23.3624 19.35V6.29998C23.3624 5.02498 22.275 3.97498 20.9999 3.97498ZM2.99995 5.66248H5.02495V6.41248C5.02495 6.86248 5.39995 7.27498 5.88745 7.27498C6.37495 7.27498 6.74995 6.89998 6.74995 6.41248V5.66248H17.3624V6.41248C17.3624 6.86248 17.7374 7.27498 18.2249 7.27498C18.7124 7.27498 19.0875 6.89998 19.0875 6.41248V5.66248H20.9999C21.3749 5.66248 21.6749 5.96248 21.6749 6.33748V8.81248H2.36245V6.33748C2.36245 5.92498 2.62495 5.66248 2.99995 5.66248ZM20.9999 19.9875H2.99995C2.62495 19.9875 2.32495 19.6875 2.32495 19.3125V10.4625H21.6374V19.35C21.6749 19.725 21.3749 19.9875 20.9999 19.9875Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7999 11.5125H9.97485C9.74985 11.5125 9.59985 11.6625 9.59985 11.8875V12.7125C9.59985 12.9375 9.74985 13.0875 9.97485 13.0875H10.7999C11.0249 13.0875 11.1749 12.9375 11.1749 12.7125V11.8875C11.1749 11.6625 10.9874 11.5125 10.7999 11.5125Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2125 11.5125H13.3875C13.1625 11.5125 13.0125 11.6625 13.0125 11.8875V12.7125C13.0125 12.9375 13.1625 13.0875 13.3875 13.0875H14.2125C14.4375 13.0875 14.5875 12.9375 14.5875 12.7125V11.8875C14.5875 11.6625 14.4375 11.5125 14.2125 11.5125Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 11.5125H16.8C16.575 11.5125 16.425 11.6625 16.425 11.8875V12.7125C16.425 12.9375 16.575 13.0875 16.8 13.0875H17.625C17.85 13.0875 18 12.9375 18 12.7125V11.8875C18 11.6625 17.85 11.5125 17.625 11.5125Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 14.4H6.375C6.15 14.4 6 14.55 6 14.775V15.6C6 15.825 6.15 15.975 6.375 15.975H7.2C7.425 15.975 7.575 15.825 7.575 15.6V14.775C7.575 14.55 7.3875 14.4 7.2 14.4Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7999 14.4H9.97485C9.74985 14.4 9.59985 14.55 9.59985 14.775V15.6C9.59985 15.825 9.74985 15.975 9.97485 15.975H10.7999C11.0249 15.975 11.1749 15.825 11.1749 15.6V14.775C11.1749 14.55 10.9874 14.4 10.7999 14.4Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2125 14.4H13.3875C13.1625 14.4 13.0125 14.55 13.0125 14.775V15.6C13.0125 15.825 13.1625 15.975 13.3875 15.975H14.2125C14.4375 15.975 14.5875 15.825 14.5875 15.6V14.775C14.5875 14.55 14.4375 14.4 14.2125 14.4Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 14.4H16.8C16.575 14.4 16.425 14.55 16.425 14.775V15.6C16.425 15.825 16.575 15.975 16.8 15.975H17.625C17.85 15.975 18 15.825 18 15.6V14.775C18 14.55 17.85 14.4 17.625 14.4Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 17.2875H6.375C6.15 17.2875 6 17.4375 6 17.6625V18.4875C6 18.7125 6.15 18.8625 6.375 18.8625H7.2C7.425 18.8625 7.575 18.7125 7.575 18.4875V17.6625C7.575 17.4375 7.3875 17.2875 7.2 17.2875Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7999 17.2875H9.97485C9.74985 17.2875 9.59985 17.4375 9.59985 17.6625V18.4875C9.59985 18.7125 9.74985 18.8625 9.97485 18.8625H10.7999C11.0249 18.8625 11.1749 18.7125 11.1749 18.4875V17.6625C11.1749 17.4375 10.9874 17.2875 10.7999 17.2875Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2125 17.2875H13.3875C13.1625 17.2875 13.0125 17.4375 13.0125 17.6625V18.4875C13.0125 18.7125 13.1625 18.8625 13.3875 18.8625H14.2125C14.4375 18.8625 14.5875 18.7125 14.5875 18.4875V17.6625C14.5875 17.4375 14.4375 17.2875 14.2125 17.2875Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7077d9eeb22a427186eed4704896a9a1.svg";
export { ForwardRef as ReactComponent };